// The Vine Gallery — custom behaviour on top of Dawn.
// WhatsApp links open in their own tab: a customer who starts a chat should
// still have the shop behind them when they come back.
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a[href*="wa.me"], a[href*="api.whatsapp.com"]')
    .forEach(function (a) {
      a.setAttribute('target', '_blank');
      a.setAttribute('rel', 'noopener');
    });
});
